export const guestComps = {
  detail: {
    nav: {
      overview: "Informations",
      bookings: "Réservations",
      checkins: "Check-ins",
      invoicing: "Facturation",
    },
    personalInfo: "Informations personnelles",
    contactInfo: "Coordonnées",
    residenceInfo: "Informations de résidence",
    fields: {
      firstName: "Prénom",
      lastName: "Nom",
      document: "Document",
      nationality: "Nationalité",
      country: "Pays",
      birthDate: "Date de naissance",
      email: "E-mail",
      whatsapp: "WhatsApp",
      countryResidence: "Pays de résidence",
      cityResidence: "Ville de résidence",
      relationship: "Lien de parenté",
    },
    cols: {
      code: "Code",
      accommodation: "Hébergement",
      checkIn: "Check-in",
      checkOut: "Check-out",
      status: "Statut",
      total: "Total",
      guest: "Client",
      booking: "Réservation",
      entryDate: "Date d'entrée",
      date: "Date",
    },
    confirmed: "Confirmé",
    fiscalProfile: "Profil fiscal enregistré",
    legalName: "Raison sociale",
    taxId: "Identifiant fiscal",
    type: "Type",
    company: "Entreprise",
    individual: "Particulier",
    invoicesIssued: "Factures émises",
    empty: {
      bookings: "Aucune réservation enregistrée pour ce client.",
      checkins: "Aucun check-in enregistré pour ce client.",
      invoices: "Aucune facture émise pour ce client.",
    },
    noPdf: "Aucun PDF",
    status: {
      sent: "Émise",
      processing: "En cours de traitement",
      error: "Erreur",
      pending: "En attente",
    },
    close: "Fermer",
  },
  form: {
    editTitle: "Modifier le client",
    newTitle: "Nouveau client",
    subtitle: "Coordonnées et informations de facturation pour les prochaines réservations et factures.",
    subtitleEmbedded: "Complétez le profil et vous reviendrez à la facture sans perdre les frais.",
    backToInvoice: "Retour à la facture",
    close: "Fermer",
    customerTypeAria: "Type de client",
    typeIndividual: "Particulier",
    typeIndividualHelp: "Personne physique",
    typeCompany: "Entreprise",
    typeCompanyHelp: "Personne morale",
    identity: "Identité",
    identityDesc: "Informations qui identifient le destinataire de la facture.",
    name: "Prénom",
    namePlaceholder: "Jean",
    lastName: "Nom",
    lastNamePlaceholder: "Dupont",
    legalName: "Raison sociale",
    legalNamePlaceholder: "Société Exemple SARL",
    docTaxId: "NIF / CIF / VAT",
    docFiscal: "Document fiscal",
    docPlaceholderIndividual: "DNI, NIE ou passeport",
    docType: "Type de document",
    select: "Sélectionner",
    docDni: "DNI",
    docNie: "NIE",
    docPassport: "Passeport",
    docOther: "Autre document",
    contact: "Contact",
    contactDesc: "Canaux pour envoyer la facture ou contacter le client.",
    email: "E-mail",
    emailPlaceholder: "customer@email.com",
    phone: "Téléphone",
    fiscalAddress: "Adresse fiscale",
    fiscalAddressDesc: "Utilisée comme adresse du destinataire sur une facture complète.",
    country: "Pays",
    address: "Adresse",
    addressPlaceholder: "Rue, numéro et étage",
    city: "Ville",
    cityPlaceholder: "Paris",
    state: "Province / État",
    postalCode: "Code postal",
    postalPlaceholder: "75001",
    requiredNote: "* Champs obligatoires pour le profil fiscal",
    backToInvoiceShort: "Retour à la facture",
    cancel: "Annuler",
    saving: "Enregistrement…",
    saveChanges: "Enregistrer les modifications",
    createClient: "Créer le client",
    err: {
      name: "Saisissez le prénom.",
      lastName: "Saisissez le nom.",
      legalName: "Saisissez la raison sociale.",
      taxId: "L'identification fiscale est obligatoire pour les entreprises.",
      country: "Sélectionnez le pays.",
      address: "Saisissez l'adresse fiscale.",
      city: "Saisissez la ville.",
      postalCode: "Saisissez le code postal.",
      email: "Saisissez une adresse e-mail valide.",
      saveFailed: "Le client n'a pas pu être enregistré.",
    },
  },
  list: {
    title: "Clients de facturation",
    subtitle: "Profils fiscaux réutilisables pour émettre et consulter les factures",
    searchLabel: "Rechercher des clients",
    searchPlaceholder: "Nom, e-mail, téléphone ou document…",
    clearSearch: "Effacer la recherche",
    exporting: "Exportation...",
    exportClients: "Exporter les clients",
    newClient: "Nouveau client",
    cols: {
      fiscalClient: "Client fiscal",
      contact: "Contact",
      fiscalDocument: "Document fiscal",
      country: "Pays",
      linkedBookings: "Réservations associées",
      invoices: "Factures",
      actions: "Actions",
    },
    company: "Entreprise",
    individual: "Particulier",
    noEmail: "Aucun e-mail attribué",
    noPhone: "Aucun téléphone attribué",
    viewInvoicesTitle: "Voir {count} facture de ce client | Voir {count} factures de ce client",
    invoicesCount: "{count} facture | {count} factures",
    noInvoices: "Aucune facture",
    editClient: "Modifier le client",
    edit: "Modifier",
    viewDetail: "Voir le détail",
    view: "Voir",
    emptySearchTitle: "Aucun profil fiscal trouvé",
    emptySearchSub: "Aucun client de facturation ne correspond à “{term}”.",
    emptyTitle: "Aucun client de facturation pour le moment",
    emptySub: "Créez un profil fiscal lors de l'émission d'une facture, ou enregistrez-en un maintenant pour le réutiliser plus tard.",
    createFirst: "Créer le premier client",
    selectedClient: "Client sélectionné",
  },
  internalName: {
    addBtn: "nom interne",
    title: "Nom interne",
    hint: "Vous seul pouvez le voir. Il apparaît avant le nom public dans vos listes et calendriers.",
    removeWarn: "Il sera supprimé de vos listes. Les messages de code d'accès et l'agent IA n'indiqueront plus à quel hébergement il fait référence.",
    edit: "Modifier",
    cancel: "Annuler",
    removing: "Suppression…",
    confirmRemove: "Oui, supprimer",
    remove: "Supprimer",
    editTitle: "Modifier le nom interne",
    addTitle: "Ajouter un nom interne",
    eyebrow: "Nom interne de l'hébergement",
    modalHint: "Un nom privé pour reconnaître l'hébergement d'un coup d'œil (par exemple « Grenier Roser » ou « Deuxième »). Vos clients ne le voient jamais.",
    placeholder: "Grenier Roser",
    previewLabel: "Vous le verrez ainsi",
    saving: "Enregistrement…",
    save: "Enregistrer",
    saveFailed: "Le nom interne n'a pas pu être enregistré.",
  },
};
